export default __webpack_public_path__ + "d8f03f7bb4b1c76f95d6588354a309c0.png";